import { Component } from 'react';
import {connect} from "react-redux";
import AnalyseRisquesForm from "./AnalyseRisquesForm";
import {withRouter} from 'react-router-dom'
import {compose} from 'redux'

class EditAnalyseRisques extends Component {

    constructor(props){
        super(props);

        if(!props.analyseRisques || !props.analyseRisques.header.mobileId){
            if(props.location.pathname.includes("/pps"))
                props.history.push("/pps");
            else
                props.history.push("/analyseRisques");
        }
    }

    render() {
        return (
            <div>
                <AnalyseRisquesForm/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EditAnalyseRisques);
